import React, { useCallback, useEffect, useMemo, useState } from "react";
import { EuiCheckboxGroup, EuiFlexGroup, EuiFlexItem, EuiPanel, EuiSpacer, EuiSwitch } from "@elastic/eui";
import { toDecimalString } from "../../../../../../shared/utils/numbers";
import { BarChartPanel } from "../../../../components/Charts/BarChart";
import { BARSCHARTS } from "../constants";
import { InformeHorasPorDNSG } from "../../../../../../infraestructure/persistence/rest/InformesAdapter";
import "./styles.css";

export const BarChartPanelScreen = (props:any) =>{

    const {data,style} = props;

    const [checkboxIdToSelectedMap, setCheckboxIdToSelectedMap] = useState<any>({});
    const [all, setAll] = useState<boolean>(false);

    const checkboxes = useMemo(() => { return data.map((d:InformeHorasPorDNSG)=> { return {id:d.idDN, label:`${d.idDN} - ${d.direccionNegocio}` }}) },[data])

    const onCheckboxChange = (optionId:string) => {
        const newCheckboxIdToSelectedMap = {
          ...checkboxIdToSelectedMap,
          ...{
            [optionId]: !checkboxIdToSelectedMap[optionId],
          },
        };
    
        setCheckboxIdToSelectedMap(newCheckboxIdToSelectedMap);
      };

    useEffect(()=>{
        let newChecks = {}
        if(all)
        {
            data.forEach((d:InformeHorasPorDNSG) => {
                newChecks = {...newChecks, ...{[d.idDN]:true}}
            })
        }

        setCheckboxIdToSelectedMap(newChecks)
    },[all])
  
      const selector = () =>{
        return (
        <>
        <EuiSwitch id='chk-all-chart' label='Todos' checked={all} onChange={(e)=>setAll(!all)}/>
        <EuiSpacer size='m'/>
        <EuiCheckboxGroup
        className='chkGroupChart'
        options={checkboxes}
        idToSelectedMap={checkboxIdToSelectedMap}
        onChange={onCheckboxChange}
        />
        </>
        )
      }

    const filterObject = () => {
    return Object.keys(Object.fromEntries(Object.entries(checkboxIdToSelectedMap).filter(([key, val]) => val === true)))
    }

    const getData = useCallback(()=>{
        return data.filter((d:InformeHorasPorDNSG)=> filterObject().includes(d.idDN))
    },[data,checkboxIdToSelectedMap])

    const renderDataTooltip = (payload:any) =>{
        return payload.map((p:any,i:number)=>{
            return <p style={{color:payload[i].color, fill:payload[i].fill}}>{`${payload[i].name}: ${toDecimalString(payload[i].value)}`}</p>
        })
    }

    const customTooltip = (dataToolTip:any) => {
        const { active, payload, label } = dataToolTip;
        if (active && payload && payload.length) {
          return (
            <div className="custom-tooltip">
              <p className="label">{`${label} - ${payload[0].payload.direccionNegocio}`}</p>
              {renderDataTooltip(payload)}
            </div>
          );
        }
      
        return null;
    };

    return (
        <EuiFlexGroup style={{...{height:'95%'}, ...style}}>
            <EuiFlexItem grow={false}><EuiPanel>{selector()}</EuiPanel></EuiFlexItem>
            <EuiFlexItem>
            <BarChartPanel data={getData()} bars={BARSCHARTS} customToolTip={customTooltip} dataKeyXAsis={'idDN'} tituloY='Horas'/>
            </EuiFlexItem>
        </EuiFlexGroup>
    )
}